export default function aos() {
  Aos.init({
    once: true,
    duration: 200,
    delay: 20,
    easing: 'linear',
  }),
    100
}
